import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AppShell from '../components/AppShell';
import Toast from '../components/Toast';
import api from '../api';

/**
 * /bookmarks — Phase 7 · Change 9e
 *
 * Lists every Creator the user has bookmarked (via the star/bookmark icon on
 * their profile). Each row links to the creator's profile and shows an
 * "unbookmark" button.
 */
export default function Bookmarks() {
  const [rows, setRows] = useState(null); // null while loading
  const [toast, setToast] = useState(null);

  const refresh = () => {
    api.get('/bookmarks')
      .then(({ data }) => setRows(data.bookmarks || []))
      .catch(() => setRows([]));
  };

  useEffect(() => { refresh(); }, []);

  const remove = async (handle) => {
    try {
      await api.delete(`/bookmarks/${encodeURIComponent(handle)}`);
      setToast({ msg: `Removed @${handle}` });
      refresh();
    } catch (e) {
      setToast({ msg: e?.response?.data?.detail || 'Could not remove.' });
    }
  };

  return (
    <AppShell>
      <div className="bookmarks-page" data-testid="bookmarks-page">
        <h1 style={{ fontFamily: "'Baloo 2', system-ui", fontSize: 26, color: 'var(--text-primary)', marginBottom: 6 }}>
          🔖 Your bookmarks
        </h1>
        <p style={{ color: '#6b6580', fontSize: 14, marginBottom: 18 }}>
          Save creators you want to keep an eye on. Tap any card to open their profile.
        </p>

        {rows === null && <div className="loading-shell" data-testid="bookmarks-loading">Loading…</div>}

        {rows !== null && rows.length === 0 && (
          <div className="bookmarks-empty" data-testid="bookmarks-empty">
            <div style={{ fontSize: 46, marginBottom: 8 }}>🔖</div>
            <h2>No bookmarks yet</h2>
            <p style={{ marginTop: 6 }}>Tap the 🔖 icon on any creator's profile to save them here.</p>
            <Link
              to="/home"
              className="btn-primary"
              style={{ display: 'inline-block', marginTop: 16 }}
              data-testid="bookmarks-explore"
            >
              Explore creators
            </Link>
          </div>
        )}

        {rows !== null && rows.length > 0 && (
          <div className="bookmarks-grid" data-testid="bookmarks-grid">
            {rows.map((b) => (
              <div
                key={b.creator_handle}
                className="latest-post-card"
                style={{ display: 'flex', gap: 12, alignItems: 'center' }}
                data-testid={`bookmark-${b.creator_handle}`}
              >
                <div
                  className="mover-avatar"
                  style={{ background: `linear-gradient(135deg, ${b.gradient[0]}, ${b.gradient[1]})` }}
                >
                  {b.initials}
                </div>
                <Link
                  to={`/creator/${b.creator_handle}`}
                  style={{ flex: 1, textDecoration: 'none', color: 'inherit', minWidth: 0 }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                    <b style={{ fontSize: 15, color: 'var(--text-primary)' }}>{b.display_name}</b>
                    {b.verified && <span style={{ color: '#00B4FF', fontWeight: 700 }}>✓</span>}
                  </div>
                  <div style={{ fontSize: 12, color: '#6b6580', fontFamily: "'JetBrains Mono', monospace" }}>
                    @{b.creator_handle} · {b.current_price.toFixed(2)} pts/Bit
                  </div>
                </Link>
                <button
                  type="button"
                  className="cc-btn-back"
                  style={{ padding: '6px 12px', fontSize: 12 }}
                  onClick={() => remove(b.creator_handle)}
                  data-testid={`bookmark-remove-${b.creator_handle}`}
                >
                  Remove
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
      {toast && <Toast msg={toast.msg} onDone={() => setToast(null)} />}
    </AppShell>
  );
}
